// Runtime configuration utility
export const getBackendUrl = () => {
  // Try to get from runtime config first (allows change without rebuild)
  if (typeof window !== 'undefined' && window._env_ && window._env_.REACT_APP_BACKEND_URL) {
    return window._env_.REACT_APP_BACKEND_URL;
  }

  // Fallback to build-time environment variable
  return process.env.REACT_APP_BACKEND_URL;
};

export const getApiUrl = () => {
  return `${getBackendUrl()}/api`;
};

export const isDevEnvironment = () => {
  return typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
};